<template>
  <v-app>
    <v-app-bar app class="app-bar">
      <v-tabs v-model="currentPage" class="custom-tabs">
        <v-tab :value="1">職務経歴書</v-tab>
        <v-tab :value="2">業務関連</v-tab>
        <v-tab :value="3">テクニカル・スキルシート</v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-btn icon color="#1a73e8" @click="saveData" class="mr-2" title="保存">
        <v-tooltip activator="parent" location="bottom">保存</v-tooltip>
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn icon color="#1a73e8" class="mr-2" @click="handleReset" title="スキルシート初期化">
        <v-tooltip activator="parent" location="bottom">スキルシート初期化</v-tooltip>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn icon color="#1a73e8" class="mr-2" @click="close" title="閉じる">
        <v-tooltip activator="parent" location="bottom">閉じる</v-tooltip>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-container class="content-container">
      <!-- page 1: 職務経歴書 -->
      <!-- page title -->
      <h1 v-if="currentPage === 1">職務経歴書</h1>
      <div v-else-if="currentPage === 2" class="d-flex align-center justify-center" style="position: relative; min-height: 56px;">
        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              icon="mdi-help-circle-outline"
              color="primary"
              class="position-absolute"
              style="left: 0; margin-bottom: 3vh;"
            />
          </template>
          <span>・ピンアイコンを押下したら、PDF出力する時該当入力欄のサイズが固定になります。<br />
          ・固定サイズは1ページに入力欄三つが入れるくらいです。<br />
          ・入力した値の長さが固定サイズを超えた場合は超えた分が...に表示されます。
          </span>
        </v-tooltip>
        <h1 class="ma-0">業務関連</h1>
      </div>
      <h1 v-else-if="currentPage === 3">テクニカル・スキルシート</h1>
      <div v-if="currentPage === 1">
        <v-card class="mb-6" outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="氏名" v-model="page1Data.name" outlined maxlength="90"
                  @input="validateName"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="最寄り駅" v-model="page1Data.location" outlined maxlength="90"
                  @input="validateLocation"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select label="性別" v-model="page1Data.gender" :items="['男', '女', '選択しない']"></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field label="年齢" type="number" v-model="page1Data.age" outlined
                  :error-messages="page1Data.ageError" max="999" @input="validateAge"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="最終学歴" v-model="page1Data.finalEducationalBackground" outlined maxlength="90"
                  @input="validateFinalEducationalBackground"></v-text-field>
              </v-col>
            </v-row>
            <v-textarea label="略歴" v-model="page1Data.summary" outlined :error-messages="page1Data.summaryError"
              :counter="maxLength" @input="() => validateInput('summary')"></v-textarea>
            <v-textarea label="自己PR" v-model="page1Data.selfPR" outlined :error-messages="page1Data.selfPRError"
              :counter="maxLength" @input="() => validateInput('selfPR')"></v-textarea>
            <v-textarea label="得意分野" v-model="page1Data.specialty" outlined :error-messages="page1Data.specialtyError"
              :counter="maxLength" @input="() => validateInput('specialty')"></v-textarea>
            <v-textarea label="保有資格" v-model="page1Data.qualifications" outlined
              :error-messages="page1Data.qualificationsError" :counter="maxLength"
              @input="() => validateInput('qualifications')"></v-textarea>
          </v-card-text>
        </v-card>
      </div>

      <!-- page 2: 開発経験 -->
      <div v-if="currentPage === 2">
        <v-card class="mb-6" outlined>
          <v-card-text>
            <div v-for="(entry, index) in page2Data.entries" :key="index" class="mb-4">
              <h3 class="d-flex align-center justify-center position-relative">
                <div class="position-absolute" style="left: 0;">
                  <v-btn icon @click="entry.isFixed = entry.isFixed ? 0 : 1" :color="entry.isFixed ? 'primary' : 'grey'">
                    <v-icon>{{ entry.isFixed ? 'mdi-pin' : 'mdi-pin-off' }}</v-icon>
                  </v-btn>
                </div>
                開発経験 {{ index + 1 }}
              </h3>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field label="開発期間(開始日)" type="date" v-model="entry.startPeriod" outlined min="1900-01-01"
                    max="3000-12-31" @change="handleDateChange(entry)"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field label="開発期間(完了日)" type="date" v-model="entry.endPeriod" outlined min="1900-01-01"
                    max="3000-12-31" @change="handleDateChange(entry)"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field label="開発期間(自動計算)" type="text" v-model="entry.totalPeriod" outlined maxlength="10"
                    @input="manualInput(entry, $event)"></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field label="役割" v-model="entry.role" outlined :counter="100" maxlength="100"
                    @input="() => validateInputRole('role', index)"></v-text-field>
                </v-col>
              </v-row>
              <v-textarea label="業務内容" v-model="entry.details" outlined :counter="maxLength"
                @input="() => validateInput2('details', index)"></v-textarea>
              <v-textarea label="開発環境等" v-model="entry.environment" outlined :counter="maxLength"
                @input="() => validateInput2('environment', index)"></v-textarea>
              <v-row class="d-flex justify-end align-items-center mt-4">
                <v-col cols="1">
                  <v-btn color="primary" @click="addNewEntry">追加</v-btn>
                </v-col>
                <v-col cols="auto" v-if="page2Data.entries.length > 1">
                  <v-btn color="error" @click="removeCareerItemsEntry(index)" class="ml-2">
                    削除
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <!-- page 3: (テクニカル・スキルシート) -->
      <div v-if="currentPage === 3">
        <div class="table-container">
          <div class="table-wrapper">
            <table>
              <!-- 1 左の方面 -->
              <thead>
                <tr>
                  <th class="vertical-text">分&#x3000;類</th>
                  <th>
                    <span class="header-title">名&#x3000;称</span>
                    <br />
                    <span class="header-note">（右下の該当セルに○を付ける）</span>
                  </th>
                  <th class="vertical-text" style="padding: 0px">
                    基本知識のみ
                  </th>
                  <th class="vertical-text" style="padding: 0px">
                    実践経験ある
                  </th>
                  <th class="vertical-text" style="padding: 0px">
                    一人で実践可能
                  </th>
                  <th class="vertical-text" style="padding: 0px">
                    ユーザー指導可能
                  </th>
                  <th class="vertical-text" style="padding: 0px">無し</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(skill, index) in page3Data.skills" :key="index">
                  <td v-if="shouldShowCategory(page3Data.skills, index)" :rowspan="getRowSpan(page3Data.skills, index)"
                    class="vertical-text">
                    {{ skill.category }}
                  </td>

                  <!-- 名前が編集可能かを確認し、クリックで編集 -->
                  <td class="editable">
                    <template v-if="skill.isEditing">
                      <input v-model="skill.editedBracketValue" placeholder="内容を入力してください" @blur="stopEditing1(skill)"
                        @keydown.enter="stopEditing1(skill)" @keydown.tab.prevent="stopEditing1(skill)"
                        class="editable-input" :ref="'inputRef' + skill.sheetId" />
                    </template>
                    <template v-else>
                      <v-tooltip text="クリックして編集できます" v-if="isEditable(skill.name, skill)">
                        <template #activator="{ on, attrs }">
                          <span class="highlight-editable" v-html="formatSkillName(skill.name)" v-bind="attrs" v-on="on"
                            @click="startEditing1(skill, 'name')"></span>
                        </template>
                      </v-tooltip>

                      <span v-else v-html="formatSkillName(skill.name)"></span>
                    </template>
                  </td>

                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="基本知識のみ" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="実践経験ある" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="一人で実践可能" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="ユーザー指導可能" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="無し" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-wrapper">
            <div class="table-wrapper">
              <table>
                <!-- 2 右の方面-->
                <thead>
                  <tr>
                    <th class="vertical-text">分&#x3000;類</th>
                    <th>
                      <span class="header-title">名&#x3000;称</span>
                      <br />
                      <span class="header-note">（右下の該当セルに○を付ける）</span>
                    </th>
                    <th class="vertical-text" style="padding: 0px">
                      基本知識のみ
                    </th>
                    <th class="vertical-text" style="padding: 0px">
                      実践経験ある
                    </th>
                    <th class="vertical-text" style="padding: 0px">
                      一人で実践可能
                    </th>
                    <th class="vertical-text" style="padding: 0px">
                      ユーザー指導可能
                    </th>
                    <th class="vertical-text" style="padding: 0px">無し</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(skill, index) in page3Data.skills2" :key="index">
                    <td v-if="shouldShowCategory(page3Data.skills2, index)"
                      :rowspan="getRowSpan(page3Data.skills2, index)" class="vertical-text">
                      {{ skill.category }}
                    </td>

                    <td class="editable">
                      <input v-if="skill.isEditing && skill.editingField === 'name'" v-model="skill.editedBracketValue"
                        placeholder="内容を入力してください" @blur="stopEditing2(skill)" @keydown.enter="stopEditing2(skill)"
                        :ref="'inputRef' + skill.sheetId" />

                      <template v-else>
                        <v-tooltip text="クリックして編集できます" v-if="isEditable(skill.name, skill)">
                          <template #activator="{ on, attrs }">
                            <span class="highlight-editable" v-html="formatSkillName(skill.name)" v-bind="attrs"
                              v-on="on" append-inner-icon="mdi-pencil" @click="startEditing2(skill, 'name')"></span>
                          </template>
                        </v-tooltip>

                        <span v-else v-html="formatSkillName(skill.name)"></span>
                      </template>
                    </td>

                    <td class="radio-cell">
                      <input type="radio" v-model="skill.skillLevel" value="基本知識のみ" />
                    </td>
                    <td class="radio-cell">
                      <input type="radio" v-model="skill.skillLevel" value="実践経験ある" />
                    </td>
                    <td class="radio-cell">
                      <input type="radio" v-model="skill.skillLevel" value="一人で実践可能" />
                    </td>
                    <td class="radio-cell">
                      <input type="radio" v-model="skill.skillLevel" value="ユーザー指導可能" />
                    </td>
                    <td class="radio-cell">
                      <input type="radio" v-model="skill.skillLevel" value="無し" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
            <!-- 3 取得資格 -->
            <table style="width: 100%; border-collapse: collapse; margin-top: 0.1vh;">
              <thead>
                <tr>
                  <th style="text-align: left; padding-bottom: 0.5vh;">取得資格(6個まで)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(skill, index) in page3Data.userInput" :key="index">
                  <td>
                    <div style="display: flex; gap: 1vh; align-items: center;">
                      <input
                        type="text"
                        v-model="skill.name"
                        placeholder="資格名"
                        maxlength="13"
                        style="width: 45%; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px;"
                      />
                      <input
                        type="text"
                        v-model="skill.skillLevel"
                        placeholder="取った日付など"
                        maxlength="11"
                        style="width: 45%; padding: 4px 8px; border: 1px solid #ccc; border-radius: 4px;"
                      />
                      <button
                        @click="addRow"
                        :disabled="page3Data.userInput.length > 5"
                        style="background-color: #007bff; color: white; border: none; padding: 6px 10px; border-radius: 4px; cursor: pointer; white-space: nowrap;"
                        :style="page3Data.userInput.length > 5 ? 'background-color: #ccc; cursor: not-allowed;' : ''"
                        title="追加"
                      >
                        追加
                      </button>
                      <button
                        @click="removeRow(index)"
                        :disabled="page3Data.userInput.length === 1"
                        style="background-color: #dc3545; color: white; border: none; padding: 6px 10px; border-radius: 4px; cursor: pointer; white-space: nowrap;"
                        :style="page3Data.userInput.length === 1 ? 'background-color: #ccc; cursor: not-allowed;' : ''"
                        title="削除"
                      >
                        削除
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 4 語学 -->
            <table>
              <thead>
                <tr>
                  <th>語学</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      style="width: 300px"
                      v-model="languageSkillName"
                      placeholder="入力後、EnterキーまたはTabキーを押してください。"
                      maxlength="90"
                      @keydown.enter="addSkillLanguage"
                      @keydown.tab.prevent="addSkillLanguage"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="skill-box-container">
              <div
                v-for="(skill, index) in page3Data.userInputLanguage"
                :key="index"
                class="skill-box"
              >
                {{ skill.skillLevel }}
                <button @click="removeUserInputLanguage(index)">×</button>
              </div>
            </div>
          </div>
            <!-- 5 ヒューマンスキル-->
            <table>
              <thead>
                <tr>
                  <th style="
                      padding: 0px;
                      text-align: center;
                      background-color: #d9d9d9;
                    "></th>
                  <th style="
                      padding: 0px;
                      text-align: center;
                      background-color: #d9d9d9;
                    "></th>
                  <th style="padding: 0px; text-align: center">不得意</th>
                  <th style="padding: 0px; text-align: center">人並み</th>
                  <th style="padding: 0px; text-align: center">得意</th>
                  <th style="padding: 0px; text-align: center">超得意</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(skill, index) in page3Data.humanSkill" :key="index">
                  <td v-if="shouldShowCategory(page3Data.humanSkill, index)"
                    :rowspan="getRowSpan(page3Data.humanSkill, index)" class="vertical-text">
                    {{ skill.category }}
                  </td>
                  <td>{{ skill.name }}</td>

                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="不得意" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="人並み" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="得意" />
                  </td>
                  <td class="radio-cell">
                    <input type="radio" v-model="skill.skillLevel" value="超得意" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="error" class="text-red">
        {{ error }}
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { defineComponent } from "vue";
import skillSheetApi from "@/api/skillSheet";
import staffApi from "@/api/getStaffInfo";

export default defineComponent({
  data() {
    return {
      skillName: "", // スキル名
      languageSkillName: "", // 語学のスキル名
      error: null, // エラー処理
      currentPage: 1, // 現在ページ
      page1Data: {
        // 1ページの職務経歴書のデータ
        name: "", // 氏名
        age: "", // 年齢
        gender: "", // 性別
        location: "", // 最寄り駅
        finalEducationalBackground: "", // 最終学歴
        summary: "", // 略歴
        selfPR: "", // 自己PR
        specialty: "", // 得意分野
        qualifications: "", // 保有資格
        ageError: "", // 年齢エラー
        staffId: null, // 社員ID
        careerId: null, // 1ページの職務経歴書のID
      },
      maxLength: 5000, // 最長5000文字入力可能
      page2Data: {
        // 2ページの職務経歴書
        entries: [
          // 開発経験
          {
            startPeriod: null, // 開発期間「初め」
            endPeriod: null, // 開発期間「終了」
            totalPeriod: null, // 開発期間「Oヶ月」
            isManualInput: false, // 開発期間「Oヶ月」入力可能フラグ
            details: "", // 業務内容
            environment: "", // 開発環境等
            role: "", // 役割
            isFixed: 0, //PDF出力の時サイズを設定
            careerItemId: null, // 2ページの職務経歴書のID
            dateError: "", // 日付入力エラー
            careerId: null, // 1ページの職務経歴書のID
          },
        ],
      },
      page3Data: {
        // 3ページのテクニカル・スキルシート
        skills: [
          // スキル項目
          {
            category: "OS / NOS", // 分類
            name: "Windows 7 各エディション", // 名称
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Windows 8.1 各エディション",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Windows 10 各エディション",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Windows Embedded 各エディション",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Windows Server 2003 R2",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Windows Server 2008 R2",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Windows Server 2012 R2",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Linux（　CentoOS　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "FreeBSD",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Solaris（SUN）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "HP-UX（HP）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "AIX（IBM）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Android",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "iOS",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "メインフレーム（  MSP            ）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "OS / NOS",
            name: "Mac（          ）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "キャパシティプランニング",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "ネットワーク設計（要件定義）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "ネットワーク設計（基本設計）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "ネットワーク設計（詳細設計）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "ネットワーク設計（構築・テスト）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "サーバ設計（要件定義）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "サーバ設計（基本設計）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "サーバ設計（詳細設計）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "サーバ設計（構築・テスト）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "端末設計（要件定義）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "端末設計（基本設計）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "端末設計（詳細設計）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム設計構築",
            name: "端末設計（構築・テスト）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "Systemwalker Centric Manager",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "Systemwalker Operation Manager",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "SKYSEA",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "OpenView",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "JP1",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "Tivoli Enterprise",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "HP Insight Manager",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "HP SiteScope",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "App Manager",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "Nagios / Zabbix",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム管理",
            name: "その他（Hinemos / AsteriaWarp）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム運用",
            name: "SNMP / MIB",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム運用",
            name: "プロトコルの解析と分析",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム運用",
            name: "ネットワーク故障対応",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム運用",
            name: "サーバ故障対応",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム運用",
            name: "端末・周辺機器故障対応",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "システム運用",
            name: "ITILによるサービス運用",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "ActiveDirectory、GPO",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "DNS（Windows機能/BIND）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "Mail（Sendmail/ProcMail）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "Web（IIS/Apatch/TOMCAT/WebLogic）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "クラスタ(WSFC)",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "LDAP（　　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "サーバ技術",
            name: "性能評価 / 冗長構成",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "TCP/IP",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "L2/L3スイッチ",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "L4SW及びロードバランサー",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "ルータ（　　　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "帯域制御装置（　　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "VPN（　　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＮＷ技術",
            name: "その他（　　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
        ],
        skills2: [
          {
            category: "クラウド仮想環境",
            name: "Microsoft azure",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "クラウド仮想環境",
            name: "Microsoft AD",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "クラウド仮想環境",
            name: "Microsoft intune",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "クラウド仮想環境",
            name: "VMware vSphere Hypervisor",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "クラウド仮想環境",
            name: "VMware horizon view",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "クラウド仮想環境",
            name: "Oracle VM Virtualbox",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "クラウド仮想環境",
            name: "その他（VMware Workstation）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "ASP / ASP.NET",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: ".NET系（VB/C#）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "C / C++ / VC++",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "Visual Basic",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "Office VBA",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "VBScript",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "JAVA",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "COBOL",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "PowerShell",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "HTML / CSS",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "AJAX",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "JSP",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "PHP",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "XML",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "ActionScript（　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "JavaApplet / JavaScript",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "Perl / Ruby / Python",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "ShellScript（BASH）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "ＤＯＳバッチ",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "ＵＷＳＣ",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "開発言語",
            name: "その他（　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "Oracle",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "MS SQL Server",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "MySql",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "Access",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "PostgreSQL",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "Symfoware Server",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ＤＢ",
            name: "その他（　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "グループ",
            name: "Lotus Notes（Domino）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "グループ",
            name: "MS Exchange",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "グループ",
            name: "MS Sharepoint",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "グループ",
            name: "その他（　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "Symantec Endpoint Protection",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "Sophos Anti-Virus for Windows",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "ウイルスバスターClient / Server",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "McAfee VirusScan",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "Soliton ZERONA",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "SHieldWARE",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "Systemwalker Desktop Keeper",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "i-FILTER",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "秘文",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "IDS / IPS / UTM",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "Firewall（　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "パケットアナライザ",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "暗号化/情報漏えい対策",
            name: "その他（　　　　　　）",
            skillLevel: "無し", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
        ],
        userInput: [],// 取得資格入力欄
        userInputLanguage: [], // 語学入力欄
        humanSkill: [
          // ヒューマンスキル
          {
            category: "ヒューマンスキル",
            name: "組織の指導力",
            skillLevel: "不得意", // スキルのレベル
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ヒューマンスキル", // 分類
            name: "企画力・提案力", // 名称
            skillLevel: "不得意",
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ヒューマンスキル",
            name: "迅速・的確な判断力",
            skillLevel: "不得意",
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ヒューマンスキル",
            name: "調整力・交渉力",
            skillLevel: "不得意",
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ヒューマンスキル",
            name: "推進力・実行力",
            skillLevel: "不得意",
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
          {
            category: "ヒューマンスキル",
            name: "高生産性・高効率性",
            skillLevel: "不得意",
            careerId: null, // 1ページの職務経歴書のID
            sheetId: null, // 各項目の固有ID
          },
        ],
      },
      page2DataTrashCan: [], // 1ページの職務経歴書のゴミ箱
      page3DataTrashCan: [], // 2ページの職務経歴書のゴミ箱
      loaded: false, // 更新確認フラグ
    };
  },
  created() {
    const staffId = this.$route.query.staffId;
    const cardId = this.$route.query.cardId;
    const authUserId = localStorage.getItem("authUserId");
    const sessionKey = localStorage.getItem("sessionKey");

    this.getSkillSheetData(authUserId, sessionKey, staffId, cardId);
  },
  watch: {
    "page2Data.entries": {
      handler(entries) {
        if (this.page2Data.entries.length === 0) {
          this.addNewEntry();
        }
        if (!this.loaded) return;
        entries.forEach((entry) => {
          if (entry.isManualInput) return;
          if (entry.startPeriod && entry.endPeriod) {
            const startDate = new Date(entry.startPeriod);
            const endDate = new Date(entry.endPeriod);

            if (!isNaN(startDate) && !isNaN(endDate) && startDate <= endDate) {
              let months =
                (endDate.getFullYear() - startDate.getFullYear()) * 12 +
                (endDate.getMonth() - startDate.getMonth());

              months = Math.max(months, 1);
              entry.totalPeriod = `${months}ヶ月`;
            } else {
              alert("無効な期間です。正しい期間で入力してください。");
              entry.startPeriod = "";
              entry.endPeriod = "";
              entry.totalPeriod = "";
            }
          } else {
            entry.totalPeriod = "";
          }
        });
      },
      deep: true,
    },
    currentPage: {
      handler() {
        if (this.currentPage === 2) {
          this.loaded = true;
          console.log("2page");
        }
      },
    },
  },
  methods: {
    addRow() {
    this.page3Data.userInput.push({ category: "取得資格", name: "", skillLevel: "" });
    },
    removeRow(index) {
      if (this.page3Data.userInput.length > 1) {
        this.page3Data.userInput.splice(index, 1);
      }
    },
    // ()内が空なのかを確認「空のみの場合、True」
    isEditable(name, skill) {
      return skill?.wasEditable === true || /（\s*）/.test(name);
    },

    // クリック時、入力可能になる「()内の値が空の項目のみ」
    startEditing1(skill, field) {
      if (!skill.wasEditable) {
        if (!this.isEditable(skill.name, skill)) return; // ()の中が空ではないと編集不可
        skill.wasEditable = true;
      }

      // skill.backupValue = skill.name.match(/（(.*?)）/)?.[1] || ""; // ユーザーが最後に入力した値を保存

      const bracketMatch = skill.name.match(/（(.*?)）/);
      skill.editedBracketValue = bracketMatch ? bracketMatch[1].trim() : "";
      skill.isEditing = true;
      skill.editingField = field;

      // クリック時すぐ入力出来るようにする
      this.$nextTick(() => {
        const inputRef = this.$refs["inputRef" + skill.sheetId];
        const inputElement = Array.isArray(inputRef) ? inputRef[0] : inputRef;

        if (inputElement && inputElement.focus) {
          inputElement.focus();
          inputElement.select();
        }
      });
    },

    // ()内が空の場合、青色
    formatSkillName(name) {
      if (this.isEditable(name)) {
        return `<span class="highlight-editable"> ${name} ✎</span>`;
      }
      return name;
    },

    getRowSpan(skills, index) {
      if (index > 0 && skills[index].category === skills[index - 1].category) {
        return 0;
      }

      let count = 1;
      for (let i = index + 1; i < skills.length; i++) {
        if (skills[i].category === skills[index].category) {
          count++;
        } else {
          break;
        }
      }
      return count;
    },

    shouldShowCategory(skills, index) {
      return (
        index === 0 || skills[index].category !== skills[index - 1].category
      );
    },

    // 入力した値を名称に更新
    stopEditing1(skill) {
      skill.isEditing = false;
      skill.editingField = "";

      const trimmed = skill.editedBracketValue.trim();

      if (!trimmed) return;

      // ()内の値のみ新しい値に切り替える
      skill.name = skill.name.replace(/（.*?）/, `（${trimmed}）`);

      // 名称から()内の値のみ更新
      skill.name = skill.name.replace(
        /（.*?）/,
        `（${skill.editedBracketValue}）`
      );
    },

    // クリック時に編集モードを有効化
    startEditing2(skill, field) {
      if (!skill.wasEditable) {
        if (!this.isEditable(skill.name, skill)) return; // ()の中が空ではないと編集不可
        skill.wasEditable = true;
      }

      const bracketMatch = skill.name.match(/（(.*?)）/);
      skill.editedBracketValue = bracketMatch ? bracketMatch[1].trim() : "";
      skill.isEditing = true;

      skill.isEditing = true;
      skill.editingField = field;

      // クリック時すぐ入力出来るようにする
      this.$nextTick(() => {
        const inputElement = this.$refs["inputRef" + skill.sheetId];
        if (inputElement) {
          inputElement[0]?.focus();
        }
      });
    },

    // 入力した値を名称に更新
    stopEditing2(skill) {
      skill.isEditing = false;
      skill.editingField = "";

      const trimmed = skill.editedBracketValue.trim();

      if (!trimmed) return;

      // ()内の値のみ新しい値にreplace
      skill.name = skill.name.replace(/（.*?）/, `（${trimmed}）`);

      // 名称から()内の値のみ修正
      skill.name = skill.name.replace(
        /（.*?）/,
        `（${skill.editedBracketValue}）`
      );
    },

    manualInput(entry, event) {
      if (!entry.isManualInput) {
        entry.isManualInput = true;
      }
      entry.totalPeriod = event.target.value;
    },
    handleDateChange(entry) {
      if (entry.isManualInput) {
        entry.isManualInput = false;
      }
    },
    //年齢
    validateAge(event) {
      const value = event.target.value;

      if (value < 0) {
        this.page1Data.age = "";
        this.page1Data.ageError = "有効な年齢を入力してください。";
      } else if (value > 999) {
        this.page1Data.age = value.slice(0, 3);
        this.page1Data.ageError = "";
      } else {
        this.page1Data.ageError = "";
        this.page1Data.age = value;
      }
    },
    async getSkillSheetData(authUserId, sessionKey, staffId, cardId) {
      try {
        this.page1Data.staffId = staffId;
        const data = await skillSheetApi.getSkillSheet(
          authUserId,
          sessionKey,
          staffId
        );
        if (data.careerData) {
          this.page1Data.name = data.careerData.staffName || "";
          this.page1Data.gender = data.careerData.gender || "";
          this.page1Data.age = data.careerData.age || "";
          this.page1Data.location = data.careerData.nearestStation || "";
          this.page1Data.finalEducationalBackground = data.careerData.academic || "";
          this.page1Data.summary = data.careerData.biography || "";
          this.page1Data.selfPR = data.careerData.publicRelations || "";
          this.page1Data.specialty = data.careerData.specialtyField || "";
          this.page1Data.qualifications = data.careerData.qualification || "";
          this.page1Data.careerId = data.careerData.careerId || null;

          const careerItemsData = data.careerItemsData || [];
          const skillSheetData = data.skillSheetData || [];

          const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
          };

          this.page2Data.entries = careerItemsData.map((item) => ({
            careerId: item.careerId || null,
            careerItemId: item.careerItemId || null,
            startPeriod: formatDate(item.developmentStartDate) || null,
            endPeriod: formatDate(item.developmentEndDate) || null,
            totalPeriod: item.developmentPeriod || "",
            role: item.role || "",
            details: item.businessContent || "",
            environment: item.developmentEnvironment || "",
            isFixed: item.isFixed ?? 0
          }));

          skillSheetData.forEach((item) => {
            if (item.classification === "OS / NOS") {
              const existingSkill = this.page3Data.skills.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "システム設計構築") {
              const existingSkill = this.page3Data.skills.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "システム管理") {
              const existingSkill = this.page3Data.skills.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "システム運用") {
              const existingSkill = this.page3Data.skills.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "サーバ技術") {
              const existingSkill = this.page3Data.skills.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "ＮＷ技術") {
              const existingSkill = this.page3Data.skills.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills2.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "クラウド仮想環境") {
              const existingSkill = this.page3Data.skills2.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills2.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "開発言語") {
              const existingSkill = this.page3Data.skills2.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills2.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "ＤＢ") {
              const existingSkill = this.page3Data.skills2.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills2.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "グループ") {
              const existingSkill = this.page3Data.skills2.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills2.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "暗号化/情報漏えい対策") {
              const existingSkill = this.page3Data.skills2.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "無し";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.skills2.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "無し",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "ヒューマンスキル") {
              const existingSkill = this.page3Data.humanSkill.find(
                (skill) =>
                  skill.category === item.classification &&
                  skill.name === item.name
              );

              if (existingSkill) {
                existingSkill.skillLevel = item.skillLevel || "不得意";
                existingSkill.careerId = item.careerId;
                existingSkill.sheetId = item.sheetId;
              } else {
                this.page3Data.humanSkill.push({
                  category: item.classification,
                  name: item.name,
                  skillLevel: item.skillLevel || "不得意",
                  careerId: item.careerId,
                  sheetId: item.sheetId,
                });
              }
            } else if (item.classification === "取得資格") {
              this.page3Data.userInput.push({
                category: item.classification,
                name: item.name,
                skillLevel: item.skillLevel || "",
                careerId: item.careerId,
                sheetId: item.sheetId,
              });
              if (this.page3Data.userInput.length === 0) {
                this.page3Data.userInput.push({
                  name: "",
                  skillLevel: "",
                  category: "取得資格"
                });
              }
            } else if (item.classification === "語学") {
              this.page3Data.userInputLanguage.push({
                category: item.classification,
                name: item.name,
                skillLevel: item.skillLevel || "",
                careerId: item.careerId,
                sheetId: item.sheetId,
              });
            }
          });
        }
        console.log("データが成功的にロードされました。");

      } catch (error) {
        const status = error.status;
          if (status === 400) {
            const authUserId = localStorage.getItem("authUserId");
            const sessionKey = localStorage.getItem("sessionKey");
            this.page3Data.userInput = [{ category: "取得資格", name: "", skillLevel: "" }];
            try {
              const staffInfo = await staffApi.getStaffInfo(
                staffId,
                cardId,
                authUserId,
                sessionKey
              );
              if (staffInfo) {
                this.page1Data.name =
                  (staffInfo["社員名"] || "") +
                    "　（" +
                            (staffInfo["社員名カナ"] || "") +
                    "）" || "";

                        this.page1Data.age = staffInfo["年齢"] || "";
                this.page1Data.location = staffInfo["最寄り駅"] || "";
              }
            } catch (staffError) {
              console.error("staffInfo取得中にエラー:", staffError);
            }
          }
        }
    },
    validateField(data, field, maxLength) {
      if (data && data[field] !== undefined && data[field] !== null) {
        if (data[field].length > maxLength) {
          data[field] = data[field].slice(0, maxLength);
        }
      }
    },
    // page1Data
    validateInput(field) {
      this.validateField(this.page1Data, field, this.maxLength);
    },
    // page1Data2
    validateInput2(field, index) {
      const entry = this.page2Data.entries[index];
      this.validateField(entry, field, this.maxLength);
    },
    // page1Data2-役割
    validateInputRole(field, index) {
      const entry = this.page2Data.entries[index];
      this.validateField(entry, field, 100);
    },
    async saveSkillSheet() {
      try {
        await this.deleteSkillSheet(this.page2DataTrashCan, this.page3DataTrashCan); // スキルシートの取得資格、語学を先に削除

        for (const entry of this.page2Data.entries) {
          if (entry.startPeriod === "" || entry.endPeriod === "") {
            alert("業務関連ページの期間を確認してください。");
            return;
          }
        }
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const userName = localStorage.getItem("staffName");
        const careerData = this.page1Data;
        const careerItemsData = this.page2Data.entries;

        // Ensure page3Data.skills, userInput, and humanSkill are arrays
        const skills = Array.isArray(this.page3Data.skills)
          ? this.page3Data.skills
          : [];
        const skills2 = Array.isArray(this.page3Data.skills2)
          ? this.page3Data.skills2
          : [];
        const userInput = Array.isArray(this.page3Data.userInput)
          ? this.page3Data.userInput
          : [];
        const userInputLanguage = Array.isArray(
          this.page3Data.userInputLanguage
        )
          ? this.page3Data.userInputLanguage
          : [];
        const humanSkill = Array.isArray(this.page3Data.humanSkill)
          ? this.page3Data.humanSkill
          : [];

        // Map over the skills, humanSkill to prepare the data for saving
        const skillSheetData = [
          ...skills.map((skill) => ({
            category: skill.category,
            name: skill.name,
            skillLevel: skill.skillLevel,
            careerId: skill.careerId,
            sheetId: skill.sheetId,
          })),
          ...skills2.map((skill2) => ({
            category: skill2.category,
            name: skill2.name,
            skillLevel: skill2.skillLevel,
            careerId: skill2.careerId,
            sheetId: skill2.sheetId,
          })),
          ...humanSkill.map((skill) => ({
            category: skill.category,
            name: skill.name,
            skillLevel: skill.skillLevel,
            careerId: skill.careerId,
            sheetId: skill.sheetId,
          })),
          ...userInput.map((input) => ({
            category: input.category,
            name: input.name,
            skillLevel: input.skillLevel,
            careerId: input.careerId,
            sheetId: input.sheetId,
          })),
          ...userInputLanguage.map((input) => ({
            category: input.category,
            name: input.name,
            skillLevel: input.skillLevel,
            careerId: input.careerId,
            sheetId: input.sheetId,
          })),
        ];

        // Log skillSheetData to confirm the data
        console.log("this.page3Data.skills: ", skillSheetData);

        // Save only the necessary data to localStorage
        localStorage.setItem("skills", JSON.stringify(skills));
        localStorage.setItem("userInput", JSON.stringify(userInput));
        localStorage.setItem("humanSkill", JSON.stringify(humanSkill));

        const response = await skillSheetApi.editSkillSheet(
          authUserId,
          sessionKey,
          userName,
          careerData,
          careerItemsData,
          skillSheetData
        );
        console.log("保存成功:", response.data);
        alert("保存成功しました。");
        this.$router.go(-1);

        return response;
      } catch (error) {
        console.error("保存エラー:", error);
        throw error;
      }
    },
    async deleteSkillSheet(deletedCareerItems, deletedSkillSheetItems) {
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");

        if (
          deletedCareerItems.length > 0 ||
          deletedSkillSheetItems.length > 0
        ) {
          await skillSheetApi.deleteSkillSheet(
            authUserId,
            sessionKey,
            deletedCareerItems,
            deletedSkillSheetItems
          );
          console.log("Career items deleted:", deletedCareerItems);
          console.log("Skill sheet items deleted:", deletedSkillSheetItems);
        }
      } catch (error) {
        console.error("削除エラー:", error);
        throw error;
      }
    },
    handleReset() {
      const confirmed = window.confirm("本当に初期化しますか？");
      if (confirmed) {
        this.reset();
      }
    },
    reset() {
      this.page1Data.name = "";
      this.page1Data.location = "";
      this.page1Data.gender = "";
      this.page1Data.age = null;
      this.page1Data.finalEducationalBackground = "";
      this.page1Data.summary = "";
      this.page1Data.selfPR = "";
      this.page1Data.specialty = "";
      this.page1Data.qualifications = "";
      this.page2Data.entries.forEach((entry) => {
        entry.startPeriod = null;
        entry.endPeriod = null;
        entry.totalPeriod = "";
        entry.role = "";
        entry.details = "";
        entry.environment = "";
        entry.isFixed = 0;
      });
      // page3Data.skills
      this.page3Data.skills.forEach((skill) => {
        skill.skillLevel = "無し";
      });
      // page3Data.skills2
      this.page3Data.skills2.forEach((skill) => {
        skill.skillLevel = "無し";
      });
      // page3Data.userInput
      this.skillName = [];
      // page3Data.userInputLaguage
      this.languageSkillName = [];
      // page3Data.humanSkill
      this.page3Data.humanSkill.forEach((skill) => {
        skill.skillLevel = "不得意";
      });
      this.removeUserInputLanguage(0);

      alert("初期化されました");
    },
    close() {
      this.$router.go(-1);
    },
    removeCareerItemsEntry(index) {
      const removedEntry = this.page2Data.entries.splice(index, 1)[0];
      if (removedEntry.careerItemId != null) {
        this.page2DataTrashCan.push(removedEntry);
      } else {
        console.log(
          "追加されたばかりのアイテムのため、ゴミ箱に追加されません。"
        );
      }
    },
    removeUserInputLanguage(index) {
  const list = this.page3Data.userInputLanguage;
  if (Array.isArray(list) && list.length > index && index >= 0) {
    const removedEntry = list.splice(index, 1)[0];
    if (removedEntry && removedEntry.sheetId != null) {
      this.page3DataTrashCan.push(removedEntry);
    } else {
      console.log("追加されたばかりのアイテムのため、ゴミ箱に追加されません。");
    }
  } else {
    console.warn("指定されたインデックスが無効です:", index);
  }
},
    scrollToFirstError() {
      const errorElement =
        this.$el.querySelector("[aria-invalid='true']") ||
        this.$el.querySelector(".v-input--error");
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    saveData() {
      this.saveSkillSheet();
    },
    validatePage1() {
      console.log("page1まで完了");
      return true;
    },
    validatePage2() {
      console.log("page2まで完了");
      return true;
    },
    validatePage3() {
      console.log("page3まで完了");
      return true;
    },
    previousPage(pageNumber) {
      this.currentPage = pageNumber;
    },
    // removeSkill(index) {
    //   if (this.page3Data.userInput && this.page3Data.userInput.length > index) {
    //     this.page3Data.userInput.splice(index, 1);
    //   }
    // },
    addSkillLanguage() {
      if (this.languageSkillName) {
        if (this.page3Data.userInputLanguage.length >= 4) {
          alert("語学は4個まで登録できます");
          return;
        }
        this.page3Data.userInputLanguage.push({
          category: "語学",
          name: "語学",
          skillLevel: this.languageSkillName,
        });
        this.languageSkillName = "";
      }
    },
    addNewEntry() {
      this.page2Data.entries.push({
        careerItemId: null,
        careerId: null,
        startPeriod: null,
        endPeriod: null,
        totalPeriod: "",
        details: "",
        environment: "",
        role: "",
        dateError: "",
        isFixed: 0,
      });
    },
  },
});
</script>

<style>
/* 名称セル専用セル */
.header-title {
  font-size: 14px;
  text-align: center;
  display: block;
  margin-top: 40px;
  margin-bottom: 8px;
}

.header-note {
  font-size: 0.7rem;
  text-align: center;
  color: red;
  display: block;
  margin-top: 4px;
}

/* ラジオボタン */
.radio-cell {
  text-align: center;
  vertical-align: middle;
}

/* 編集可能な項目のみ青色で強調 */
.highlight-editable {
  color: blue;
  font-weight: bold;
  cursor: pointer;
}

.highlight-editable:hover {
  text-decoration: underline;
}

/* ユーザーがクリックしたときの入力スタイル */
.editable-input {
  border: 1px solid blue;
  padding: 2px;
}

.vertical-text {
  font-weight: bold;
  writing-mode: vertical-rl;
  text-orientation: upright;
  white-space: nowrap;
  text-align: center;
  padding: 0px;
  border: 1px solid #ddd;
  background-color: #f8f8f8;
}

.custom-tabs {
  font-size: 16px;
  font-weight: 500;
  color: #1a73e8;
  padding: 0 16px;
}

.custom-tabs .v-tab--active {
  color: #1a73e8 !important;
  font-weight: 600;
  position: relative;
}

.custom-tabs .v-tab--active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #1a73e8;
  transition: all 0.3s ease;
}

.custom-tabs .v-tab:hover {
  color: #1a73e8;
  background-color: rgba(26, 115, 232, 0.1);
  border-radius: 8px;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  color: black;
  font-weight: 600;
}

h3 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.content-container {
  margin-top: 80px;
  margin-bottom: 80px;
  padding: 20px;
}

.table-container {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

th {
  border: 1px solid #e0e0e0;
  background-color: #f9fafb;
  text-align: center;
  vertical-align: middle;
  padding: 8px;
}

td {
  border: 1px solid #e0e0e0;
  padding: 4px;
  text-align: left;
}

.skill-box-container {
  display: flex;
  flex-wrap: wrap;
}

.skill-box {
  background-color: #f9fafb;
  border: 1px solid #e0e0e0;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin: 2px;
  font-size: 12px;
  color: #4a4a4a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s, box-shadow 0.2s;
}

.skill-box:hover {
  background-color: #f3f4f6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.skill-box button {
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.2s;
}

.skill-box button:hover {
  color: #4a4a4a;
}
</style>
